import AppConfig from './AppConfig'
import Challenge from './Challenge'

/**
 * Compatibility view for legacy call sites that expect a single season + app-version config.
 * Prefer useChallengeContext() in new code.
 */
export default class SessionConfig {
  readonly challenge: Challenge
  readonly appConfig: AppConfig

  constructor(challenge: Challenge, appConfig: AppConfig) {
    this.challenge = challenge
    this.appConfig = appConfig
  }

  static from(challenge: Challenge, appConfig: AppConfig) {
    return new SessionConfig(challenge, appConfig)
  }

  get startDate() {
    return this.challenge.startDate
  }

  get endDate() {
    return this.challenge.endDate
  }

  get passPrice() {
    return this.challenge.passPrice
  }

  get teamPassPrice() {
    return this.challenge.teamPassPrice
  }

  get teamLeaderPassPrice() {
    return this.challenge.teamLeaderPassPrice
  }

  get passPriceId() {
    return this.challenge.passPriceId
  }

  get teamPassPriceId() {
    return this.challenge.teamPassPriceId
  }

  get teamLeaderPassPriceId() {
    return this.challenge.teamLeaderPassPriceId
  }

  get iosVersion() {
    return this.appConfig.iosVersion
  }

  get androidVersion() {
    return this.appConfig.androidVersion
  }

  get finishLineVideo() {
    return this.challenge.finishLineVideoUrl ?? ''
  }

  get completed() {
    return this.challenge.hasEnded()
  }

  get goal() {
    return this.challenge.goal
  }

  getDaysRemaining() {
    return this.challenge.getDaysRemaining()
  }

  getTotalDays() {
    return this.challenge.getTotalDays()
  }

  getPaceProgress() {
    return this.challenge.getPaceProgress()
  }

  hasStarted() {
    return this.challenge.hasStarted()
  }
}
